// extracted by mini-css-extract-plugin
export default {"Dialog":"lDhF7sSWRBGVdflY6bdQ","Calendar":"jMZKAkB5JUiI3LUiUF9F","Day":"H3r1ZBEg4Dq3SPIdzjYZ","WeekDay":"uTb4FJdbr_NrTmOvhmyY"};